/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Text, Depths, PrimaryButton, Spinner, SpinnerSize, Icon } from '@fluentui/react';
import { useMutation } from 'react-query';
import * as sapi from '../../services/sapi';
import theme from '../../../../theme.style';

function useCleanupStagedTxsMutation() {
  return useMutation('addContractIdToList', stagedTransactionIds =>
    sapi.del('/dri/staged-transactions', {
      ids: stagedTransactionIds,
    }),
  );
}

export default function CleanupStagedTxsRecommendation({ data }) {
  const { stagedTransactionsBreakdown } = data;
  const { ingestedIds } = stagedTransactionsBreakdown;
  const cleanupStagedTxsMutation = useCleanupStagedTxsMutation();

  return (
    <Stack
      style={{
        display: 'inline-flex',
        backgroundColor: 'white',
        boxShadow: Depths.depth4,
        padding: 20,
      }}
      tokens={{ childrenGap: 14 }}
    >
      <Text style={{ fontWeight: 'bold' }}>Cleanup Staged Transactions</Text>
      <Text style={{ fontWeight: 'normal' }}>
        There are <strong>{ingestedIds.length}</strong> staged transactions that have already been
        ingested in events or nrbtransactions. These staged transactions should be removed. Click
        the button below to delete them.
      </Text>

      {cleanupStagedTxsMutation.error && (
        <Text style={{ fontWeight: 'normal', color: theme.palette.accentError }}>
          {cleanupStagedTxsMutation.error.response?.data?.message ||
            cleanupStagedTxsMutation.error.message}
        </Text>
      )}

      {cleanupStagedTxsMutation.isSuccess && (
        <Text style={{ fontWeight: 'normal', color: theme.palette.accentTeal }}>
          <Icon iconName="StatusCircleCheckmark" />
          Successfully deleted {ingestedIds.length} staged transactions that have already been
          ingested.
        </Text>
      )}
      <PrimaryButton
        onClick={() => cleanupStagedTxsMutation.mutate(ingestedIds)}
        disabled={cleanupStagedTxsMutation.isLoading || cleanupStagedTxsMutation.isSuccess}
      >
        {cleanupStagedTxsMutation.isLoading ? (
          <Spinner size={SpinnerSize.xSmall} />
        ) : (
          'Cleanup Staged Txs'
        )}
      </PrimaryButton>
    </Stack>
  );
}

CleanupStagedTxsRecommendation.propTypes = {
  data: PropTypes.shape({}).isRequired,
};
